/**
 * @file 禁止输入表情指令
 */
import emojiRegex from 'emoji-regex'

export default {
    bind(el, binding, vnode, oldVnode) {
        const regex = emojiRegex()
        const obj = el.querySelectorAll('.el-input__inner,.el-textarea__inner')[0]
        let zclearNoNum = function (e) {
            if (e.target.composing) return
            let match = regex.exec(obj.value) //也可以直接用正则表达式判断
            if (match) {
                obj.value = obj.value.replace(/(\ud83c[\udc00-\udfff])|(\ud83d[\udc00-\udfff])|(\ud83e[\udc00-\udfff])|[\u2100-\u32ff]|[\u0030-\u007f][\u20d0-\u20ff]|[\u0080-\u00ff]/g, '')
                zclearNoNum(e)
            }
            // 触发v-model的更新
            obj.dispatchEvent(new Event('input'))
        }
        let zblur = function (e) {
            zclearNoNum(e)
            setTimeout(() => {
                let match = regex.exec(obj.value)
                if (match) {
                    obj.value = obj.value.replace(/(\ud83c[\udc00-\udfff])|(\ud83d[\udc00-\udfff])|(\ud83e[\udc00-\udfff])|[\u2100-\u32ff]|[\u0030-\u007f][\u20d0-\u20ff]|[\u0080-\u00ff]/g, '')
                    zclearNoNum(e)
                }
                // 触发v-model的更新
                obj.dispatchEvent(new Event('change'))
            }, 50)
        }
        obj.onkeyup = zclearNoNum
        obj.onblur = zblur

        function onCompositionStart(e) {
            e.target.composing = true
        }

        function onCompositionEnd(e) {
            e.target.composing = false
            obj.dispatchEvent(new Event('input'))
        }
        obj.addEventListener('compositionstart', onCompositionStart)
        obj.addEventListener('compositionend', onCompositionEnd)
    }
}

